<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data pelunasan."
            @click="save()"
            :disabled="savedisabled"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("settlement") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data pelunasan."
            @click="save()"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("settlement") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tgl_kontrak"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_agreement" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5" style="display: flex;justify-content: left;align-items: center;">
              <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.pinjaman_uraian"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB'">
                <label style="width: 140px">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width: 140px">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman == 'PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="0"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB'">
              <b-input-group-prepend>
                <label style="width: 140px">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
       <b-row>
          <b-col lg="8">
             <b-row>
              <b-col lg="5">
                <b-input-group>
                <b-input-group-prepend>
                  <label>Nomor Surat</label>
                </b-input-group-prepend>
                <div class="form-control-static pt-2">: {{frmdt.releaseno}}</div>
              </b-input-group>
              </b-col>
             </b-row>
             <b-row>
              <b-col lg="10">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl Surat</label>
                  </b-input-group-prepend>
                  <div class="form-control-static pt-2">: {{frmdt.submitdate | moment('DD MMMM YYYY')}}</div>
                </b-input-group>
              </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl Jth Tempo</label>
                  </b-input-group-prepend>
                  <div class="form-control-static pt-2">: {{frmdt.duedate_memo | moment('DD MMMM YYYY')}}</div>
                </b-input-group>
              </b-col>
              </b-row>
            
            <b-input-group>
              <b-input-group-prepend>
                <label>Kronologis</label>
              </b-input-group-prepend>
              <div class="form-control-static pt-2">:<span v-html="frmdt.kronologisTable"></span></div>
            </b-input-group>

            <b-row>
              <b-col lg="10">
                <b-input-group>
                  <b-input-group-prepend>
                    <label >Rencana Penarikan <br> Jaminan</label>
                  </b-input-group-prepend>
                  <div class="form-control-static pt-2">: {{frmdt.estimatereleasedt | moment('DD MMMM YYYY')}}</div>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>CC</label>
                  </b-input-group-prepend>
                  <div class="form-control-static pt-2"><span v-html="frmdt.ccTable"></span> </div>
                </b-input-group>
                 <b-input-group>
                  <b-input-group-prepend>
                    <label style="">Nilai Pengajuan</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend style="height: 35px">
                    <span class="input-group-text">IDR</span>
                  </b-input-group-prepend>
                  <div style="width:250px">
                    <my-number
                      v-model="frmdt.paymentamt"
                      :precision="2"
                      class="text-right"
                      disabled="disabled"
                    ></my-number>
                  </div>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="">Jumlah Pembayaran</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend style="height: 35px">
                    <span class="input-group-text">IDR</span>
                  </b-input-group-prepend>
                  <div style="width:250px">
                    <my-number
                      v-model="frmdt.akumpaidamt"
                      :precision="2"
                      class="text-right"
                      disabled="disabled"
                    ></my-number>
                  </div>
                </b-input-group>
              </b-col>
            </b-row>

          </b-col>
       </b-row>
       <hr />
      <b-row class="mt-3">
        <b-col lg="8">
          <h5>Alokasi Pembayaran</h5>
           <b-table-simple responsive bordered>
            <b-thead class="text-center">
                <b-tr>
                  <b-th>Fasilitas</b-th>
                  <b-th style="width:250px;">Tercatat</b-th>
                  <b-th style="width:250px;">Pembayaran</b-th>
                  <b-th style="width:250px;">Sisa Kewajiban</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
              
              <b-tr>
                <b-td>Pokok</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.principal_outstand |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.principal_allocation |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.principal_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Bunga</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.interest_outstand |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.interest_allocation |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.interest_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Denda</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.latecharge_outstand |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.latecharge_allocation |numFormat('0,0.00') }}</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.latecharge_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-td><b>Total</b></b-td>
                <b-td class="text-right pt-3"><b>{{this.frmdt.ttlOS |numFormat('0,0.00') }}</b></b-td>
                <b-td class="text-right pt-3 pr-4"><b>{{this.frmdt.ttlAllocation |numFormat('0,0.00') }}</b></b-td>
                <b-td class="text-right pt-3"><b>{{this.frmdt.ttlOSafteralloc |numFormat('0,0.00') }}</b></b-td>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Settlement Date</label>
            </b-input-group-prepend>
            <b-form-input
              type="date"
              v-model="frmdt.settlementdate"
              :state="!$v.frmdt.settlementdate.$error"
              :max="today"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <!-- <b-row>
          <b-col lg="12">
          <h5>Daftar Jaminan</h5>
        </b-col>
      </b-row>

      <b-card align="center" no-body>   
          <b-input-group class="m-1">
            <button
              class="btn btn-primary mr-1"
              v-b-tooltip.hover
              title="Simpan data pelunasan."
              @click="clearSelected()"
            >
                <i class="fa fa-trash-o"></i> Clear selected
            </button>
          </b-input-group>
            <b-table
              sticky-header 
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;max-height:500px !important;"
              :items="tblDataAsset.items"
              :fields="tblFieldsAsset"
              :current-page="tblDataAsset.page"
              :per-page="tblDataAsset.limit"
              :sort-by.sync="tblDataAsset.sortBy"
              :sort-desc.sync="tblDataAsset.sortDesc"
              :key="tblDataAsset.limit"
              :busy="isBusytblDataAsset"
              show-empty
              selectable
              @row-selected="onRowSelected"
              select-mode="multi"
            >
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>

            <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
              <template v-slot:cell(nilaijaminan)="data">{{
                data.item.nilaijaminan | numFormat('0,0.00')
              }}</template>
              <template v-slot:cell(nilaimargin)="data">
                <b-input-group>
                    <b-input-group-prepend style="height: 35px">
                      <span class="input-group-text">IDR</span>
                    </b-input-group-prepend>
                    <my-number
                      v-model="data.item.nilaimargin"
                      :precision="2"
                      class="text-right"
                    ></my-number>
                  </b-input-group>
              </template>
              <template v-slot:cell(nilailikuidasi)="data">
                <b-input-group>
                    <b-input-group-prepend style="height: 35px">
                      <span class="input-group-text">IDR</span>
                    </b-input-group-prepend>
                    <my-number
                      v-model="data.item.nilailikuidasi"
                      :precision="2"
                      class="text-right"
                    ></my-number>
                  </b-input-group>
              </template>
              <template v-slot:cell(alamat)="data">
                {{ data.item.alamat || "-" }}
                
                <span v-if="(data.item.kelurahan ||'')!=''">
                  <br />
                   Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
                  data.item.kecamatan
                }}</span>
                <span v-if="(data.item.kota||'')!=''">
                  <br />
                  Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
                </span>
                <span v-if="(data.item.kodepos||'')!=''">
                  <br />
                  Kode Pos : {{ data.item.kodepos }}
                </span>
                
              </template>
              <template v-slot:cell(detail)="data">
                <span v-if="data.item.tipejaminan == 'Kendaraan'">
                  <b-row>
                    <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
                    <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
                    <b-col md="6"
                      >- Tanggal STNK :
                      {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col
                    >
                  </b-row>
                </span>
                <span v-else>
                  <b-row>
                    <b-col md="6"
                      >- No Sertifikat : {{ data.item.sertifikatno }}</b-col
                    >
                    <b-col md="6"
                      >- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      - Luas Tanah : {{ data.item.luastanah }} m
                      <sup>2</sup>
                    </b-col>
                    <b-col md="6">
                      - Luas Bangunan : {{ data.item.luasbangunan }} m
                      <sup>2</sup>
                    </b-col>
                  </b-row>
                  - Status Sertifikat : {{ data.item.sertifikatstatus }}
                  <span v-if="data.item.sertifikatstatus === 'lainnya'"
                    >- {{ data.item.otherstatussertifikat }}</span
                  >
                  <b-row>
                    <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
                    <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6"
                      >- Status Asuransi : {{ data.item.statusasuransi }}</b-col
                    >
                    <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
                  </b-row>
                </span>
              </template>
              <template v-slot:cell(tgl_kontrak)="data">{{
                data.item.tgl_kontrak | moment("DD/MM/YY")
              }}</template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div align="left">
                  Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
                  to
                  <span
                    v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)"
                  >{{tblDataAsset.total}}</span>
                  <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
                  of {{tblDataAsset.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25,50,75,100]"
                        :plain="true"
                        v-model="tblDataAsset.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataAsset.total"
                  :per-page="tblDataAsset.limit"
                  v-model="tblDataAsset.page"
                  @click="getAssetData()"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card> -->

    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import asset from "../../apis/agunankredit";
import releasedoc from "../../apis/releasedoc";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required,minValue } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, Loading },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      settlementdate: { required }
    },
  },
  data() {
    return {
      today:moment().format('YYYY-MM-DD'),
      savedisabled:false,
      showReport: false,
      reportUrl: null,
      isLoading: false,
      text: "",
      isBusy: false,
      isBusytblDataAsset:false,
      isPelunasankey: false,
      model: {},
      frmdt: {
        releaseKey:'',
        pinjamankey: "",
        submitdate: moment().format("YYYY-MM-DD"),
        duedate: moment().add(1,'month').format("YYYY-MM-DD"),
        tglpelunasan: moment().format("YYYY-MM-DD"),
        hariini: moment().format("YYYY-MM-DD"),
        releaseno: "",
        kronologis:'',
        paymentamt:0,
        jaminanamt:0,
        principal_outstand:0,
        interest_outstand:0,
        latecharge_outstand:0,
        principal_allocation:0,
        interest_allocation:0,
        latecharge_allocation:0,
        principal_OSafteralloc:0,
        interest_OSafteralloc:0,
        latecharge_OSafteralloc:0,
        ttlOS:0,
        ttlAllocation:0,
        ttlOSafteralloc:0,
        kepada: "Komite Kredit",
        perihal: "Credit Settlement Approval",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        cc: "- Loan Admin (untuk menyiapkan SKL & surat roya) \n- Audit",
        docReleaseArr:[]
     },
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      ifCalculated: false,
      stateTtlPay: true,
      lkuPinjamanShow: false,
      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
      documentSelected: []
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      return this.$v.frmdt.$invalid;
    },
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
    tblFieldsAsset() {
      const fields = [
        'selected',
        { key: "index", label: "#" },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:1500px",
          sortable: true,
        },
        
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilaimargin",
          label: "Nilai Margin",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilailikuidasi",
          label: "Nilai Likuidasi",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        }
      ];
      return fields;
    },
  },
  watch: {
    "frmdt.principal_allocation"(val) {
      this.frmdt.principal_OSafteralloc = this.frmdt.principal_outstand - val;
      this.calcpaymn();
    },
    "frmdt.interest_allocation"(val) {
      this.frmdt.interest_OSafteralloc = this.frmdt.interest_outstand - val;
      this.calcpaymn();
    },
    "frmdt.latecharge_allocation"(val) {
      this.frmdt.latecharge_OSafteralloc = this.frmdt.latecharge_outstand - val;
      this.calcpaymn();
    }
  },
  created: async function () {
    this.model.model_pinjaman = "PAB";
    if (this.$route.params.releaseKey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await releasedoc.detail(this.$route.params.releaseKey);
        const header = res[0][0];
        const assetRelease = res[1];
        let assets = res[2];
        

        let documentSelected=[];
        assetRelease.map((asset)=>{
            let index = assets.findIndex(x=>x.jaminankey == asset.jaminankey);
            documentSelected.push(assets[index]);
            assets[index].rowSelected=true;
        });
        this.documentSelected = documentSelected;

        this.tblDataAsset.items=assets;
        this.tblDataAsset.total = assets.length;

        for (const key in header) {
          this.model[key] = header[key];
          this.frmdt[key] = header[key];
        }

        
        this.frmdt.submitdate = this.frmdt.submitdate
          ? moment(this.frmdt.submitdate).format("YYYY-MM-DD")
          : "";
        this.frmdt.duedate = this.frmdt.duedate
          ? moment(this.frmdt.duedate).format("YYYY-MM-DD")
          : "";
        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.estimatereleasedt = this.frmdt.estimatereleasedt
          ? moment(this.frmdt.estimatereleasedt).format("YYYY-MM-DD")
          : "";

        this.frmdt.tipepelunasan = header.tipepelunasan;
        this.frmdt.nilaijaminan = header.nilaijaminan;
        console.log('frmdt.cc',this.frmdt.cc);
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
    
  },
  methods: {
    calcpaymn() {
      this.frmdt.ttlOS= this.frmdt.principal_outstand+this.frmdt.interest_outstand+this.frmdt.latecharge_outstand;
      this.frmdt.ttlAllocation= this.frmdt.principal_allocation+this.frmdt.interest_allocation+this.frmdt.latecharge_allocation;
      this.frmdt.ttlOSafteralloc= this.frmdt.principal_OSafteralloc+this.frmdt.interest_OSafteralloc+this.frmdt.latecharge_OSafteralloc;

    },
    close() {
      router.push({ name: "loan.settlementpelepasanjaminan" });
    },
    async save() {
      if (this.invalidFrmDt) {
        console.log("validation : ", this.$v.frmdt);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
            const data = await releasedoc.settlement(this.frmdt);
            this.frmdt.releaseKey = data.releaseKey;
            toastr.success("Data berhasil disimpan");
            router.push({ name: "loan.pelepasanjaminansebagian" });
        
      }
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
    async getAssetData(){
      try {
        this.isLoading=true;
        const list = await asset.getAsset(this.model.pinjamankey);
        this.tblDataAsset.items=list;
        this.tblDataAsset.total = list.length;
        if(list.length<1){
          toastr.warn('Tidak dapat mengajukan pelepasan jaminan.Pinjaman ini hanya memiliki satu jaminan');
          this.savedisabled=true;
        }
        this.isLoading=false; 
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
  },
};
</script>
